<template>
  <div>
    <!-- Question info -->
    <table class="table col-10">
      <tbody>
        <tr>
          <th>
            Question Information
            <a href="#question-info-modal" class="u-inline">
              <i class="fa fa-wrapper fa-info-circle" style="color: blue;"> </i>
            </a>
          </th>
          <td>
            <abbr v-if="question.uuid" :title="question.uuid">
              {{ handleUUID(question.uuid) }}
            </abbr>
          </td>
          <td>Revision {{ question.revision }}</td>
          <td>
            <question-status v-bind:question="question"></question-status>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Question info modal -->
    <div
      id="question-info-modal"
      class="modal modal-large modal-animated--dropdown modal-normal"
    >
      <a href="#target" class="modal-overlay close-btn" aria-label="Close"></a>
      <div class="modal-content" role="document">
        <div class="modal-header">
          <a href="#components" class="u-pull-right" aria-label="Close">
            <span class="icon">
              <i class="fa fa-wrapper fa-times"></i>
            </span>
          </a>
          <div class="modal-title">Question Information</div>
          <div class="modal-subtitle">What all this information means</div>
        </div>
        <div class="divider u-no-margin"></div>
        <div class="modal-body">
          <dl>
            <dt>UUID (e.g. <i>...64e70d</i>)</dt>
            <dd>
              This is the <i>Universal Unique ID (UUID)</i> for the question.
              This code is used to keep track of a question as it's amended and
              changed over time.
            </dd>
            <dt>
              Revision
            </dt>
            <dd>
              When a question is updated, the <i>Revision is updated</i>.
              Importantly, the <i>UUID stays the same</i> so that the question's
              history can be tracked.
            </dd>
            <dt>
              <i class="fa fa-wrapper fa-font" style="color: green;"></i>
              &nbsp;or&nbsp;
              <i class="fa fa-wrapper fa-list-ul" style="color: blue;"></i>
              &nbsp;Question Type
            </dt>
            <dd>
              The number of <i>choices</i> entered for a question determines
              whether it is:
              <ul>
                <li>
                  <i>Multiple Choice</i> (
                  <i class="fa fa-wrapper fa-list-ul" style="color: blue;"> </i>
                  ) if <strong>more than</strong>
                  <span class="error"> one</span> choice is entered
                </li>
                <li>
                  <i>Short Answer</i> (
                  <i class="fa fa-wrapper fa-font" style="color: green;"> </i>
                  ) if <span class="error">only </span> <strong>one</strong>
                  choice is entered
                </li>
              </ul>
            </dd>
            <dt>
              <i
                class="fa fa-wrapper fa-check-double"
                style="color: green;"
              ></i>
              Published (In Exam)
            </dt>
            <dd>
              A <i>Published</i> question is preserved in order to preserve the
              exam papers the question has been used in.
              <br />
              If you edit a <i>Published</i> question then a
              <i>new revision</i>
              will be created for that question.
            </dd>
            <dt>
              <i
                class="fa fa-wrapper fa-exclamation-circle"
                style="color: #dc4753;"
              ></i>
              &nbsp;Mandatory Question
            </dt>
            <dd>
              A <i>Mandatory</i> question will be included in
              <strong>all </strong> exams which include that topic.
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import QuestionStatus from "@/components/questions/QuestionStatus";

export default {
  name: "question-info",
  components: {
    QuestionStatus
  },
  props: ["question"],
  methods: {
    handleUUID: function(uuid) {
      return "..." + uuid.slice(-7, -1);
    }
  }
};
</script>
